import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../_shared/services/authentication/authentication.service';
import { States } from '../../_store/app.reducer';
import { Store } from '@ngrx/store';
import { logout } from '../../_store/app.actions';
import { Subscription } from 'rxjs';
import { RuntimeConfigService } from '../../_shared/services/services-index';

@Component({
    selector: 'navbar-logout',
    templateUrl: './navbar-logout.component.html',
    standalone: false
})
export class NavbarLogoutComponent {
    @Input() locale: string;
    constructor(
        private store$: Store<States.AppState>,
        private authService: AuthenticationService,
        private runtimeConfigService: RuntimeConfigService,
        private router: Router) { }

    logout() {
        this.store$.dispatch(logout());
        this.authService.resetUser();

        const logoutRoute = this.runtimeConfigService.routingConfig.find(r => r.id === 'logout');

        if (!!logoutRoute) {
          this.router.navigate(['/logout'])
        }
        else {
          this.router.navigate(['/login']);
        }
    }
}
